// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__34Grw","menuItem":"styles_menuItem__42wHG","paper":"styles_paper__3qjYj","chip":"styles_chip__3MC4i"};